export default __webpack_public_path__ + "static/faq-background-f90b66c9e410d3a889729240a60ac4a0.jpg";